// Responsive layout rule:
// - Use MobileOnly and DesktopOnly when mobile and desktop need different structure.
// - Use max-lg: classes for mobile-only styling.
// - Use lg: classes for desktop-only styling.
// - Do not make unprefixed layout changes unless they are meant for both mobile and desktop.
// - Major hero sections, CTA rows, pricing grids and complex card grids must be protected before visual redesign.

import React from 'react';

type DeviceLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export function MobileOnly({ children, className = '' }: DeviceLayoutProps) {
  return (
    <div className={`block lg:hidden ${className}`}>
      {children}
    </div>
  );
}

export function DesktopOnly({ children, className = '' }: DeviceLayoutProps) {
  return (
    <div className={`hidden lg:block ${className}`}>
      {children}
    </div>
  );
}

export function DesktopSection({
  children,
  className = '',
}: DeviceLayoutProps) {
  return (
    <div className={`hidden lg:block ${className}`}>
      <div className="mx-auto max-w-7xl px-8 xl:px-0">
        {children}
      </div>
    </div>
  );
}

export function MobileSection({
  children,
  className = '',
}: DeviceLayoutProps) {
  return (
    <div className={`block lg:hidden ${className}`}>
      {children}
    </div>
  );
}

export function ResponsiveSection({
  children,
  className = '',
}: DeviceLayoutProps) {
  return (
    <section className={className}>
      {children}
    </section>
  );
}

export function ResponsiveContainer({
  children,
  className = '',
}: DeviceLayoutProps) {
  return (
    <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
}
